import { differenceInDays } from 'date-fns';
import { makeAutoObservable } from 'mobx';

import { fetchAvailableDocumentOfTruthTypes } from 'api/billing';
import { countryIds } from 'constants/routeParams';
import { SiteFeaturesIDs } from 'store/SiteFeatures/SiteFeatures';
import { etrnBannerClosedTimestampStorage } from 'utils/storage/Storage';

import { RootStore } from '../RootStore';

const repeatShowIntervalDays = 7;

// Баннер показываем только ИП и юрлицам. Из всего словаря форм собственности
// (https://files.ati.su/glossary/ru/ownerships.json) исключаем только те, что не ИП и не юрлицо.
const excludedOwnershipIds = [
  0, // (другая) — форма собственности не подтверждена
  25, // физ.лицо
  76, // СЗ — самозанятое лицо
];

class EtrnBannerStore {
  root;
  closedTimestamp: number = etrnBannerClosedTimestampStorage.get();
  hasDataMatchPoint: boolean | null = null;

  constructor(root: RootStore) {
    this.root = root;

    makeAutoObservable(this);
  }

  get isFeatureEnabled() {
    return Boolean(this.root.siteFeatures.isSiteFeatureEnabled[SiteFeaturesIDs.etrnReadyBanner]);
  }

  get isAvailableForUser() {
    const profile = this.root.profile.data?.profile;

    const isRussianAccount = profile?.countryId === Number(countryIds.russia);
    const isCompanyOrSoleProprietor =
      profile?.ownershipId !== undefined && !excludedOwnershipIds.includes(profile.ownershipId);

    return isRussianAccount && isCompanyOrSoleProprietor;
  }

  get isDismissed() {
    if (!this.closedTimestamp) return false;

    return differenceInDays(Date.now(), this.closedTimestamp) < repeatShowIntervalDays;
  }

  get isVisible() {
    return this.isFeatureEnabled && this.isAvailableForUser && this.hasDataMatchPoint === true && !this.isDismissed;
  }

  setHasDataMatchPoint = (value: boolean) => {
    this.hasDataMatchPoint = value;
  };

  fetchConfirmationStatus = async () => {
    if (!this.isFeatureEnabled || !this.isAvailableForUser || this.isDismissed) return;

    try {
      const { hasDataMatchPoint } = await fetchAvailableDocumentOfTruthTypes();

      this.setHasDataMatchPoint(hasDataMatchPoint);
    } catch (error) {
      console.error(error);
    }
  };

  close = () => {
    this.closedTimestamp = Date.now();
    etrnBannerClosedTimestampStorage.set(this.closedTimestamp);
  };
}

export { EtrnBannerStore };
